export function freezeBodyScrolling() {
  document.body.style.overflow = 'hidden'
}

export function unfreezeBodyScrolling() {
  document.body.style.overflow = ''
}
